/** Lowercase ledger / snapshot `source` keys → user-facing labels (audit log, tables, etc.). */
const LEDGER_SOURCE_LABELS: Record<string, string> = {
  amazon_csv_import: "Amazon CSV Import",
  amazon_selling_partner: "Amazon Selling Partner",
  shopify_csv_import: "Shopify CSV Import",
  csv_import: "CSV Import",
  csv: "CSV Import",
  manual_received: "Manual receipt",
  shopify: "Shopify",
  amazon: "Amazon",
  veeqo: "Veeqo",
  woocommerce: "WooCommerce",
  manual: "Manual Entry",
  xero: "Xero",
  quickbooks: "QuickBooks",
};

function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/** Substring humanization: longest keys first. Omits `csv` — it matches the acronym inside labels like "Shopify CSV Import". */
const SORTED_LEDGER_SOURCE_KEYS_FOR_TEXT = Object.keys(LEDGER_SOURCE_LABELS)
  .filter((k) => k !== "csv")
  .sort((a, b) => b.length - a.length);

/** Map a single `source` / origin key to a short UI label. */
export function formatInventoryLedgerSourceForDisplay(source: string): string {
  const trimmed = source.trim();
  if (!trimmed) return source;

  const mapped = LEDGER_SOURCE_LABELS[trimmed.toLowerCase()];
  if (mapped) return mapped;

  if (trimmed.includes("_")) {
    return trimmed
      .split("_")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(" ");
  }

  return trimmed;
}

/** Replace known ledger source slugs in free-form text (e.g. variance notes). Longest keys first. */
export function humanizeLedgerSourceSlugsInText(text: string): string {
  let out = text;
  for (const key of SORTED_LEDGER_SOURCE_KEYS_FOR_TEXT) {
    const re = new RegExp(`\\b${escapeRegExp(key)}\\b`, "gi");
    out = out.replace(re, LEDGER_SOURCE_LABELS[key]);
  }
  return out;
}
